import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { Helmet } from "react-helmet-async";

import {
  servicesData as initialServicesData,
  newsData as initialNewsData,
  testimonialsData as initialTestimonialsData,
  getAgentsData,
} from "../Constants/Data";
import ServiceCard from "../Components/ServiceCard";
import NewsCard from "../Components/NewsCard";
import PageBanner from "../Components/PageBanner";

import Image1 from "../assets/1.jpeg";
import Image2 from "../assets/2.jpg";
import coverImage from "../assets/20.jpg";
import Profile from "../assets/profile.jpg";

export default function About() {
  const [newsData, setNewsData] = useState([]);
  const [servicesData, setServicesData] = useState([]);
  const [testimonialsData, setTestimonialsData] = useState([]);
  const [agentsData, setAgentsData] = useState([]);

  const [cardsPerRow, setCardsPerRow] = useState(3);

  const [servicesIndex, setServicesIndex] = useState(0);
  const [agentsIndex, setAgentsIndex] = useState(0);
  const [testimonialsIndex, setTestimonialsIndex] = useState(0);
  const [newsIndex, setNewsIndex] = useState(0);

  useEffect(() => {
    setNewsData(initialNewsData);
    setServicesData(initialServicesData);
    setTestimonialsData(initialTestimonialsData);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getAgentsData();
        if (Array.isArray(data)) {
          const filteredAgents = data.filter(
            (agent) => agent.role_id !== 1 && agent.role_id !== 2,
          );
          setAgentsData(filteredAgents);
        } else {
          setAgentsData([]);
        }
      } catch (error) {
        setAgentsData([]);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const updateCardsPerRow = () => {
        const width = window.innerWidth;

        if (width < 768) {
          setCardsPerRow(1); // mobile
        } else if (width < 992) {
          setCardsPerRow(2); // tablet
        } else {
          setCardsPerRow(3); // desktop
        }
      };

      updateCardsPerRow();
      window.addEventListener("resize", updateCardsPerRow);

      return () => window.removeEventListener("resize", updateCardsPerRow);
    }
  }, []);

  const totalServiceSlides = Math.ceil(
    (servicesData?.length || 0) / cardsPerRow,
  );

  const serviceItems = servicesData.slice(
    servicesIndex,
    servicesIndex + cardsPerRow,
  );

  const visibleItems = newsData.slice(newsIndex, newsIndex + cardsPerRow);

  const visibleAgentItems = agentsData.slice(
    agentsIndex,
    agentsIndex + cardsPerRow,
  );

  const testimonalsItems = testimonialsData.slice(
    testimonialsIndex,
    testimonialsIndex + cardsPerRow,
  );

  const handleNext = (section) => {
    switch (section) {
      case "services":
        if (servicesIndex + cardsPerRow < servicesData.length) {
          setServicesIndex((prevIndex) => prevIndex + 1);
        }
        break;
      case "agents":
        if (agentsIndex + cardsPerRow < agentsData.length) {
          setAgentsIndex((prevIndex) => prevIndex + 1);
        }
        break;
      case "testimonials":
        if (testimonialsIndex + cardsPerRow < testimonialsData.length) {
          setTestimonialsIndex((prevIndex) => prevIndex + 1);
        }
        break;
      case "news":
        if (newsIndex + cardsPerRow < newsData.length) {
          setNewsIndex((prevIndex) => prevIndex + 1);
        }
        break;
      default:
        break;
    }
  };

  const handlePrev = (section) => {
    switch (section) {
      case "services":
        if (servicesIndex > 0) {
          setServicesIndex((prevIndex) => prevIndex - 1);
        }
        break;
      case "agents":
        if (agentsIndex > 0) {
          setAgentsIndex((prevIndex) => prevIndex - 1);
        }
        break;
      case "testimonials":
        if (testimonialsIndex > 0) {
          setTestimonialsIndex((prevIndex) => prevIndex - 1);
        }
        break;
      case "news":
        if (newsIndex > 0) {
          setNewsIndex((prevIndex) => prevIndex - 1);
        }
        break;
      default:
        break;
    }
  };

  return (
    <>
      <Helmet>
        <title>About | Urban View Real Estate PVT LTD</title>
        <meta
          name="description"
          content="Find affordable homes for sale & rent across Australia with Urban View Real Estate. Explore investment properties in Brisbane, Sydney suburbs, Queensland & Melbourne."
        />
        <meta
          name="keywords"
          content="Affordable Homes for Sale in South Australia, Affordable Homes for Sale in Melbourne, Affordable Homes for Sale in Queensland, Development Sites for Sale in Sydney, Cheap Rent a Home in Penrith, House Buying in Western Australia, Cheap Duplex Home in Tamworth, Affordable duplex Home in Armidale, Houses for Rental in St Marys, Investement Property in Queensland, Best Investment Property Sale in Brisbane, Best Investment Property Sale in Rouse Hill, Box Hill, Marsden Park, Vineyard, Investment Property Buy in Austral, Investment Property Buy in Tallawong, Investment Property Buy in Oran Park, Investment Property Buy in Leppington"
        />

        <meta name="author" content="Urban View Real Estate PVT LTD" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://urbanviewre.com/about" />

        <meta property="og:title" content="Urban View Real Estate PVT LTD" />
        <meta
          property="og:description"
          content="Find affordable homes for sale & rent across Australia with Urban View Real Estate. Explore investment properties in Brisbane, Sydney suburbs, Queensland & Melbourne."
        />
        <meta property="og:site_name" content="Urban View Real Estate" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://urbanviewre.com" />
        <meta
          property="og:image"
          content="https://urbanviewre.com/assets/logo-2-CGgGTWZk.png"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Urban View Real Estate PVT LTD" />
        <meta
          name="twitter:description"
          content="Find affordable homes for sale & rent across Australia with Urban View Real Estate. Explore investment properties in Brisbane, Sydney suburbs, Queensland & Melbourne."
        />
        <meta
          name="twitter:image"
          content="https://urbanviewre.com/assets/logo-2-CGgGTWZk.png"
        />
        <meta name="twitter:site" content="@urbanviewre" />
        <meta name="twitter:creator" content="@urbanviewre" />

        <meta
          property="fb:admins"
          content="https://www.facebook.com/profile.php?id=61559035348971"
        />

        <meta name="instagram:title" content="Urban View Real Estate PVT LTD" />
        <meta
          name="instagram:description"
          content="Find affordable homes for sale & rent across Australia with Urban View Real Estate. Explore investment properties in Brisbane, Sydney suburbs, Queensland & Melbourne."
        />
        <meta name="instagram:site" content="@urbanviewrealestate" />
      </Helmet>

      <PageBanner
        title="About Us"
        breadcrumbs={[
          { label: "Home", href: "/", icon: "bi-house-door-fill" },
          { label: "About Us", active: true },
        ]}
      />

      <section className="py-5">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-12 col-lg-6 d-flex">
              <div className="about-image-stack bg-light position-relative w-100 overflow-hidden">
                <img
                  src={Image1}
                  alt="Urban View Real Estate"
                  className="about-main-image d-block w-100 h-100"
                />

                <div className="about-overlay-image-wrap bg-white position-absolute bottom-0 end-0">
                  <img
                    src={Image2}
                    alt="Urban View Interior"
                    className="about-overlay-image d-block object"
                  />
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-6 text-start">
              <h6 className="badge text-primary rounded-4 fw-bold px-3 fs-6">
                About Us
              </h6>
              <h2 className="fw-bold brand py-2">
                The Leading Real Estate Rental Marketplace.
              </h2>

              <span className="brand fw-bold">Mission</span>
              <p className="text-muted mt-1">
                At UrbanView, our mission is simple: to provide exceptional real
                estate services that exceed expectations. We are committed to
                guiding our clients through every step of the buying, selling,
                or leasing process with professionalism and integrity.
              </p>

              <span className="brand fw-bold">Our Commitment</span>
              <p className="text-muted mt-1">
                At UrbanView, we are dedicated to building long-term
                relationships with our clients. We measure our success by your
                satisfaction and strive to exceed your expectations in every
                transaction.
              </p>

              <div className="row text-start mt-2">
                <div className="col-12 col-sm-6 d-flex align-items-center mb-3">
                  <span
                    className="rounded-circle text-primary fs-4"
                    style={{
                      padding: "10px 15px",
                      background: "rgba(0, 176, 247, 0.1)",
                    }}
                  >
                    <i className="bi bi-house-door"></i>
                  </span>
                  <span className="ms-3">Smart Home Design</span>
                </div>

                <div className="col-12 col-sm-6 d-flex align-items-center mb-3">
                  <span
                    className="rounded-circle text-primary fs-4"
                    style={{
                      padding: "10px 15px",
                      background: "rgba(0, 176, 247, 0.1)",
                    }}
                  >
                    <i className="bi bi-image"></i>
                  </span>
                  <span className="ms-3">Beautiful Scene Around</span>
                </div>

                <div className="col-12 col-sm-6 d-flex align-items-center mb-3">
                  <span
                    className="rounded-circle text-primary fs-4"
                    style={{
                      padding: "10px 15px",
                      background: "rgba(0, 176, 247, 0.1)",
                    }}
                  >
                    <i className="bi bi-stars"></i>
                  </span>
                  <span className="ms-3">Exceptional Lifestyle</span>
                </div>

                <div className="col-12 col-sm-6 d-flex align-items-center mb-3">
                  <span
                    className="rounded-circle text-primary fs-4"
                    style={{
                      padding: "10px 15px",
                      background: "rgba(0, 176, 247, 0.1)",
                    }}
                  >
                    <i className="bi bi-shield-lock"></i>
                  </span>
                  <span className="ms-3">Complete 24/7 Security</span>
                </div>
              </div>

              <div
                className="p-4 mt-2 border-start border-4 border-primary"
                style={{ background: "rgba(0, 176, 247, 0.1)" }}
              >
                <p className="mb-0 text-muted">
                  <i>
                    "UrbanView envisions a seamless real estate experience,
                    offering smart homes, breathtaking surroundings, and 24/7
                    security. Committed to integrity and innovation, we create
                    thriving communities where clients find exceptional
                    lifestyles and lasting relationships."
                  </i>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="slider py-5 text-center">
        <div className="container">
          <h6 className="badge text-primary rounded-4 fw-bold px-3 fs-6">
            Our Services
          </h6>
          <h2 className="fw-bold brand py-3">Our Main Focus</h2>

          <div className="mt-5 position-relative">
            <div className="row mt-4 flex-nowrap overflow-hidden justify-content-start align-items-stretch">
              {serviceItems.map((service) => (
                <ServiceCard key={service.id} {...service} />
              ))}
            </div>

            <button
              className="carousel-control-prev rounded-circle border position-absolute"
              type="button"
              style={{
                top: "50%",
                zIndex: "2",
                width: "50px",
                height: "50px",
              }}
              onClick={() => handlePrev("services")}
              disabled={servicesIndex === 0}
              aria-label="Previous"
            >
              <span aria-hidden="true">
                <i className="bi bi-arrow-left text-dark fs-4"></i>
              </span>
              <span className="visually-hidden">Previous</span>
            </button>

            <button
              className="carousel-control-next rounded-circle border position-absolute"
              type="button"
              style={{
                top: "50%",
                zIndex: "2",
                width: "50px",
                height: "50px",
              }}
              onClick={() => handleNext("services")}
              disabled={servicesIndex + cardsPerRow >= servicesData.length}
              aria-label="Next"
            >
              <span aria-hidden="true">
                <i className="bi bi-arrow-right text-dark fs-4"></i>
              </span>
              <span className="visually-hidden">Next</span>
            </button>

            <div
              className="d-flex justify-content-center mt-4"
              role="group"
              aria-label="Services slide navigation"
            >
              {Array.from(
                { length: Math.min(5, totalServiceSlides || 0) },
                (_, index) => {
                  const slideIndex =
                    totalServiceSlides > 0
                      ? Math.floor(
                          (servicesIndex / cardsPerRow) % totalServiceSlides,
                        )
                      : 0;

                  return (
                    <span
                      key={index}
                      className={`dot ${index === slideIndex ? "active" : ""}`}
                      onClick={() => setServicesIndex(index * cardsPerRow)}
                      style={{ cursor: "pointer" }}
                    ></span>
                  );
                },
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Agents Section */}
      <section className="slider py-5 text-center">
        <div className="container">
          <h6 className="badge text-primary rounded-4 fw-bold px-3 fs-6">
            Teams
          </h6>
          <h2 className="fw-bold brand py-3">Property Agents</h2>

          <div className="mt-5 position-relative">
            <div className="row mt-4 align-items-stretch">
              {visibleAgentItems.length > 0 ? (
                visibleAgentItems.map((agent) => (
                  <div
                    className="col-12 col-md-6 col-lg-4 d-flex justify-content-center mb-4"
                    key={agent.id || `${agent.firstname}-${agent.lastname}`}
                  >
                    <div className="card text-center rounded-0 agent-card w-100">
                      {agent.profileimg ? (
                        <Link
                          to={`/team-details/${encodeURIComponent(
                            `${agent.firstname}-${agent.lastname}`,
                          )}`}
                          className="text-decoration-none text-dark"
                          aria-label={`View profile of ${agent.firstname} ${agent.lastname}`}
                        >
                          <img
                            src={agent.profileimg}
                            alt={agent.firstname || "Agent"}
                            className="card-img-top"
                            style={{
                              objectFit: "cover",
                              height: "300px",
                              width: "100%",
                            }}
                          />
                        </Link>
                      ) : (
                        <div className="d-flex align-items-center justify-content-center h-100 p-5">
                          <p className="mb-0">No Image Available</p>
                        </div>
                      )}

                      <div className="card-body">
                        <Link
                          to={`/team-details/${encodeURIComponent(
                            `${agent.firstname}-${agent.lastname}`,
                          )}`}
                          className="text-decoration-none text-dark"
                          aria-label={`View profile of ${agent.firstname} ${agent.lastname}`}
                        >
                          <h5 className="fw-bold cursor-pointer">
                            {agent.firstname || "Unknown"}{" "}
                            {agent.lastname || ""}
                          </h5>
                        </Link>

                        <p className="text-primary fw-semibold">
                          {agent.designation || "No Designation"}
                        </p>

                        <div className="d-flex justify-content-center gap-3">
                          {agent.social_media?.facebook && (
                            <a
                              href={agent.social_media.facebook}
                              className="text-dark fs-5"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <i className="bi bi-facebook"></i>
                            </a>
                          )}

                          {agent.social_media?.twitter && (
                            <a
                              href={agent.social_media.twitter}
                              className="text-dark fs-5"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <i className="bi bi-twitter"></i>
                            </a>
                          )}

                          {agent.social_media?.linkedin && (
                            <a
                              href={agent.social_media.linkedin}
                              className="text-dark fs-5"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <i className="bi bi-linkedin"></i>
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-center">Loading ...</p>
              )}
            </div>

            <button
              className="carousel-control-prev rounded-circle border position-absolute"
              type="button"
              style={{
                top: "50%",
                zIndex: "2",
                width: "50px",
                height: "50px",
              }}
              onClick={() => handlePrev("agents")}
              disabled={agentsIndex === 0}
              aria-label="Previous"
            >
              <span aria-hidden="true">
                <i className="bi bi-arrow-left text-dark fs-4"></i>
              </span>
              <span className="visually-hidden">Previous</span>
            </button>

            <button
              className="carousel-control-next rounded-circle border position-absolute"
              type="button"
              style={{
                top: "50%",
                zIndex: "2",
                width: "50px",
                height: "50px",
              }}
              onClick={() => handleNext("agents")}
              disabled={agentsIndex + cardsPerRow >= agentsData.length}
              aria-label="Next"
            >
              <span aria-hidden="true">
                <i className="bi bi-arrow-right text-dark fs-4"></i>
              </span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="slider py-5 text-center">
        <div
          className="container pt-5"
          style={{
            backgroundImage: `url(${coverImage})`,
            backgroundRepeat: "no-repeat",
          }}
        >
          <h6 className="badge text-primary rounded-4 fw-bold px-3 mt-5 fs-6">
            Our Testimonial
          </h6>
          <h2 className="fw-bold brand py-3">Clients Feedback</h2>

          <div className="mt-5 position-relative">
            <div className="row d-md-flex justify-content-center align-items-stretch">
              {testimonalsItems.map((testimonial) => (
                <div
                  className="col-12 col-md-6 col-lg-4 mb-4 d-flex"
                  key={testimonial.id}
                >
                  <div
                    className="card shadow-sm border-0 p-3 rounded-0 service-card d-flex flex-column w-100"
                    style={{
                      minHeight: "100%",
                      overflow: "hidden",
                    }}
                  >
                    <div className="card-body d-flex flex-column">
                      <p
                        className="text-muted text-start small"
                        style={{ flexGrow: 1 }}
                      >
                        <i className="bi bi-quote text-primary"></i>{" "}
                        {testimonial.feedback}
                      </p>

                      <div className="d-flex align-items-center mt-3 gap-2">
                        <img
                          src={
                            testimonial.image?.url ||
                            testimonial.image ||
                            Profile
                          }
                          alt={testimonial.name || "Client"}
                          className="rounded-circle"
                          style={{ width: "50px", height: "50px" }}
                          onError={(e) => {
                            e.target.src = Profile;
                          }}
                        />
                        <div className="text-start align-items-center">
                          <h6 className="mb-0 fw-bold">{testimonial.name}</h6>
                          <small className="text-muted">
                            {testimonial.role}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <button
              className="carousel-control-prev rounded-circle border position-absolute"
              type="button"
              style={{
                top: "50%",
                zIndex: "2",
                width: "50px",
                height: "50px",
              }}
              onClick={() => handlePrev("testimonials")}
              disabled={testimonialsIndex === 0}
              aria-label="Previous"
            >
              <span aria-hidden="true">
                <i className="bi bi-arrow-left text-dark fs-4"></i>
              </span>
            </button>

            <button
              className="carousel-control-next rounded-circle border position-absolute"
              type="button"
              style={{
                top: "50%",
                zIndex: "2",
                width: "50px",
                height: "50px",
              }}
              onClick={() => handleNext("testimonials")}
              disabled={
                testimonialsIndex + cardsPerRow >= testimonialsData.length
              }
              aria-label="Next"
            >
              <span aria-hidden="true">
                <i className="bi bi-arrow-right text-dark fs-4"></i>
              </span>
            </button>
          </div>
        </div>
      </section>

      {/* News Section */}
      {/* 
      <section className="slider py-5 mb-5 text-center">
        <div className="container">
          <h6 className="badge text-primary rounded-4 fw-bold px-3 fs-6">
            News & Blogs
          </h6>
          <h2 className="fw-bold brand py-3">Latest News Feeds</h2>

          <div className="mt-5 position-relative">
            <div className="row">
              {visibleItems.map((news) => (
                <div className="col-12 col-md-6 col-lg-4 mb-4" key={news.id}>
                  <NewsCard
                    image={news.image}
                    title={news.title}
                    author={news.author}
                    category={news.category}
                    date={news.date}
                    link={news.link}
                  />
                </div>
              ))}
            </div>

            <button
              className="carousel-control-prev rounded-circle border position-absolute"
              type="button"
              style={{
                top: "50%",
                zIndex: "2",
                width: "50px",
                height: "50px",
              }}
              onClick={() => handlePrev("news")}
              disabled={newsIndex === 0}
            >
              <span aria-hidden="true">
                <i className="bi bi-arrow-left text-dark fs-4"></i>
              </span>
              <span className="visually-hidden">Previous</span>
            </button>

            <button
              className="carousel-control-next rounded-circle border position-absolute"
              type="button"
              style={{
                top: "50%",
                zIndex: "2",
                width: "50px",
                height: "50px",
              }}
              onClick={() => handleNext("news")}
              disabled={newsIndex + cardsPerRow >= newsData.length}
            >
              <span aria-hidden="true">
                <i className="bi bi-arrow-right text-dark fs-4"></i>
              </span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </div>
      </section>
      */}

      <section className="bg-light py-5">
        <div className="client-logos d-flex overflow-hidden position-relative py-5">
          {/* <div className="logo-wrapper d-flex">
            {Clients.concat(Clients).map((imageSrc, index) => (
              <img
                src={imageSrc}
                alt={`Client Logo ${index + 1}`}
                key={`client-${index}`}
                className="client-logo"
              />
            ))}
          </div> */}
        </div>
      </section>
    </>
  );
}
